import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { v4 as uuidv4 } from 'uuid';

const supabaseUrl: string = 'https://fkposdatcvfixtymeohe.supabase.co';
const supabaseKey: string =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZrcG9zZGF0Y3ZmaXh0eW1lb2hlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjM2MjE1NDQsImV4cCI6MjAzOTE5NzU0NH0.ueLQD9lYtN0SLsQaG4to_kiu94RDCnI5RPhD7TOGZPA';
const supabase: SupabaseClient = createClient(supabaseUrl, supabaseKey);

interface MindsetQuestion {
  id: number;
  question_de: string;
  question_en: string;
  dimension_id: number;
}
/*
const answers = {
  data: [
    { question_id: 1, answer: 4 },
    { question_id: 2, answer: 5 },
    { question_id: 3, answer: 3 },
    { question_id: 4, answer: 6 },
    { question_id: 5, answer: 2 },
    { question_id: 6, answer: 1 },
    { question_id: 7, answer: 5 },
    { question_id: 8, answer: 3 },
    { question_id: 9, answer: 4 },
    { question_id: 10, answer: 2 },
    { question_id: 11, answer: 1 },
    { question_id: 12, answer: 4 },
    { question_id: 13, answer: 5 },
    { question_id: 14, answer: 3 },
    { question_id: 15, answer: 6 },
    { question_id: 16, answer: 2 },
    { question_id: 17, answer: 1 },
    { question_id: 18, answer: 5 },
    { question_id: 19, answer: 3 },
    { question_id: 20, answer: 4 },
    { question_id: 21, answer: 2 },
    { question_id: 22, answer: 6 },
    { question_id: 23, answer: 5 },
    { question_id: 24, answer: 3 },
    { question_id: 25, answer: 4 },
    { question_id: 26, answer: 2 },
    { question_id: 27, answer: 1 },
    { question_id: 28, answer: 5 },
    { question_id: 29, answer: 3 },
    { question_id: 30, answer: 4 },
    { question_id: 31, answer: 6 },
    { question_id: 32, answer: 2 },
    { question_id: 33, answer: 1 },
    { question_id: 34, answer: 5 },
    { question_id: 35, answer: 3 },
    { question_id: 36, answer: 4 },
  ],
};*/

window.Webflow ||= [];
window.Webflow.push(async () => {
  const form: HTMLFormElement | null = document.querySelector(
    '[kw-element="free-assessment-form"]'
  );
  const spinner: HTMLDivElement | null = document.querySelector('[kw-element="spinner"]');

  if (spinner) spinner.style.display = 'flex';
  if (form) form.style.display = 'none';

  try {
    await loadQuestions();
    initForm();
    await getDimensionScores('fa02d91c-dd21-4df8-ab0c-8f9dc8d9990f');
  } catch (error) {
    console.error('Initialization error:', error);
  } finally {
    if (spinner) spinner.style.display = 'none';
    if (form) form.style.display = 'block';
  }

  async function loadQuestions(): Promise<void> {
    try {
      const { data, error } = await supabase.from('mindset_questions').select('*');
      if (error) throw new Error(`Error fetching questions: ${error.message}`);
      console.log('Questions loaded:', data);
      populateWebflowWithQuestions(data);
    } catch (error) {
      console.error('Unexpected error in loadQuestions:', error);
    }
  }

  function populateWebflowWithQuestions(questions: MindsetQuestion[]): void {
    const template = document.querySelector('[kw-element="questions-template"]') as HTMLElement;
    if (!template) {
      console.error('Template element not found.');
      return;
    }

    questions.forEach((question) => {
      const questionElement = template.cloneNode(true) as HTMLElement;

      // Update the cloned template with question data
      questionElement.querySelector('[kw-element="question__title"]')!.innerHTML =
        question.question_de;

      questionElement
        .querySelectorAll<HTMLInputElement>('input[type="radio"]')
        .forEach((radioButton) => {
          radioButton.setAttribute('data-name', question.id.toString());
          radioButton.setAttribute('name', question.id.toString());
        });

      // Insert the question element into the DOM
      template.parentNode?.insertBefore(questionElement, template.nextSibling);
    });

    // Remove the template element after cloning
    template.remove();
  }

  function initForm() {
    if (form) {
      form.onsubmit = (event) => {
        event.preventDefault();
        const radioButtons = form.querySelectorAll<HTMLInputElement>('input[type="radio"]:checked');
        onSubmitForm(radioButtons);
      };
    }
  }

  async function onSubmitForm(radioButtons: NodeListOf<HTMLInputElement>) {
    const answers = Array.from(radioButtons).map((radioButton) => ({
      question_id: parseInt(radioButton.getAttribute('data-name') || '0'),
      answer: parseInt(radioButton.value),
    }));

    const resultId = uuidv4();
    const { error } = await supabase.from('answers_mindset_assessment').insert([
      {
        id: resultId,
        answers,
        created_at: new Date().toISOString(),
      },
    ]);

    if (error) {
      console.error('Error storing user answers:', error);
    } else {
      const currentUrl = new URL(window.location.href);
      currentUrl.pathname = '/assessments/free-assessment-result';
      currentUrl.searchParams.set('result_id', resultId);
      window.location.href = currentUrl.toString();
    }
  }

  async function getDimensionScores(resultId: string) {
    const response = await fetch(
      `${supabaseUrl}/functions/v1/calc-free-scores?result_id=${resultId}`,
      { method: 'GET', headers: { 'Content-Type': 'application/json' } }
    );
    if (!response.ok) {
      throw new Error(`Failed to fetch scores: ${await response.text()}`);
    }
    console.log('Scores:', await response.json());
  }
});
